export default __webpack_public_path__ + "static/media/WebSite.917b5c7f.svg";